import { useRef, useState } from "react";
import { Upload, Loader2, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { imgSrc } from "../../lib/siteContent";

export default function ImageUploadField({ value, onChange, label = "Image", testId = "image-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && (
        <label className="text-xs font-mono uppercase tracking-[0.2em] text-[#5A5A72]">{label}</label>
      )}
      <div className="mt-2 flex items-center gap-4">
        <div className="w-20 h-20 rounded-xl overflow-hidden border border-black/[0.1] bg-white grid place-items-center flex-shrink-0">
          {value ? (
            <img src={imgSrc(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon className="w-6 h-6 text-[#9191A8]" />
          )}
        </div>
        <div className="flex-1">
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testId}-file`} />
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            data-testid={`${testId}-btn`}
            className="btn-ghost px-4 py-2 rounded-lg text-xs font-mono uppercase tracking-wider flex items-center gap-2 disabled:opacity-60"
          >
            {uploading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
            {uploading ? "Uploading..." : value ? "Replace image" : "Upload image"}
          </button>
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="or paste an image URL"
            data-testid={`${testId}-url`}
            className="mt-2 w-full px-3 py-2 rounded-lg bg-white border border-black/[0.08] focus:border-[#00D4FF]/60 outline-none text-xs text-[#0E0E1A]"
          />
        </div>
      </div>
    </div>
  );
}
